<template>
  <div class="container-fluid">
    <div class="block-header position-sticky">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <!-- <div class="card">
                    <div class="header border-bottom">
                        <h5 class="text-primary font-weight-normal mb-0">Sender (Send money from)</h5>
                    </div>
                    <div class="body">
                        <b-table 
                            responsive
                            outlined
                            table-class="mb-0 table-custom"
                            head-variant="light"
                            :items="sendersFrom" 
                            :fields="sendersFromfields"
                            :emptyText="'No data found.'" show-empty striped>
                            <template #cell(email)="data">
                                {{ data.value }} <i class="fa fa-copy" v-if="data.value != '-'" @click="copyText(data.value,'Email')"></i>
                            </template>
                            <template #cell(mobile)="data">
                                {{ data.value }} <i class="fa fa-copy" v-if="data.value != '-'" @click="copyText(data.value,'Mobile Number')"></i>
                            </template>
                            <template #cell(country)="data">
                                <div class="align-items-center d-flex">
                                    <span v-if="data.value.isocode != '-'" :class="`flag-icon flag-icon-${data.value.isocode} fi-16 fi-round`"></span>
                                    <span class="ml-2" v-b-tooltip.hover :title="data.value.countryname">{{data.value.isocode?.toUpperCase() }}</span>
                                </div>
                            </template>
                            <template #cell(block_status)="data">
                                <select class="btn btn-filter badge badge-primary btn-sm" v-model="data.value">
                                    <option value="">Select Option</option>
                                    <option v-for="(option,index) in blockStatuses" :key="index" :value="option">{{ option.value }}</option>
                                </select>
                            </template>
                        </b-table>
                    </div>
                </div> -->
        <div class="card">
          <div class="header border-bottom">
            <h5 class="text-primary font-weight-normal mb-0">Senders</h5>
          </div>
          <div class="body">
            <b-table
              responsive
              outlined
              table-class="mb-0 table-custom"
              head-variant="light"
              :items="sendersTo"
              :fields="sendersTofields"
              :emptyText="'No data found.'"
              show-empty
              striped
            >
              <template #cell(name)="data">
                <a
                  href="javascript:void(0);"
                  class="font-color"
                  @click="editCustomer(data)"
                >
                  {{ data.value }}
                </a>
              </template>
              <template #cell(email)="data">
                {{ data.value }}
                <i
                  class="fa fa-copy"
                  v-if="data.value != '-'"
                  @click="copyText(data.value, 'Email')"
                ></i>
              </template>
              <template #cell(mobile)="data">
                {{ data.value }}
                <i
                  class="fa fa-copy"
                  v-if="data.value != '-'"
                  @click="copyText(data.value, 'Mobile Number')"
                ></i>
              </template>
              <template #cell(country)="data">
                <div class="align-items-center d-flex">
                  <span
                    v-if="data.value.isocode != '-'"
                    :class="`flag-icon flag-icon-${data.value.isocode} fi-16 fi-round`"
                  ></span>
                  <span
                    class="ml-2"
                    v-b-tooltip.hover
                    :title="data.value.countryname"
                  >
                    {{ data.value?.isocode?.toUpperCase() }}
                  </span>
                </div>
              </template>
              <template #cell(block_status)="data">
                <select
                  class="btn btn-filter badge badge-primary btn-sm"
                  v-model="data.value"
                >
                  <option value="">Select Option</option>
                  <option
                    v-for="(option, index) in blockStatuses"
                    :key="index"
                    :value="option"
                  >
                    {{ option.value }}
                  </option>
                </select>
              </template>
            </b-table>
          </div>
        </div>
        <div class="card">
          <div class="header border-bottom">
            <h5 class="text-primary font-weight-normal mb-0">Receivers</h5>
          </div>
          <div class="body">
            <b-table
              responsive
              outlined
              table-class="mb-0 table-custom"
              head-variant="light"
              :items="receivers"
              :fields="receiversfields"
              :emptyText="'No data found.'"
              show-empty
              striped
            >
              <template #cell(name)="data">
                <a
                  href="javascript:void(0);"
                  class="font-color"
                  @click="editCustomer(data)"
                >
                  {{ data.value }}
                </a>
              </template>
              <template #cell(email)="data">
                {{ data.value }}
                <i
                  class="fa fa-copy"
                  v-if="data.value != '-'"
                  @click="copyText(data.value, 'Email')"
                ></i>
              </template>
              <template #cell(mobile)="data">
                {{ data.value }}
                <i
                  class="fa fa-copy"
                  v-if="data.value != '-'"
                  @click="copyText(data.value, 'Mobile Number')"
                ></i>
              </template>
              <template #cell(country)="data">
                <div class="align-items-center d-flex">
                  <span
                    v-if="data.value.isocode != '-'"
                    :class="`flag-icon flag-icon-${data.value.isocode} fi-16 fi-round`"
                  ></span>
                  <span
                    class="ml-2"
                    v-b-tooltip.hover
                    :title="data.value.countryname"
                  >
                    {{ data.value?.isocode?.toUpperCase() }}
                  </span>
                </div>
              </template>
              <template #cell(block_status)="data">
                <select
                  class="btn btn-filter badge badge-primary btn-sm"
                  v-model="data.value"
                >
                  <option value="">Select Option</option>
                  <option
                    v-for="(option, index) in blockStatuses"
                    :key="index"
                    :value="option"
                  >
                    {{ option.value }}
                  </option>
                </select>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import {
  GET_CUSTOMERS_BY_BANKACCOUNT,
  GET_CUSTOMERS_BY_MOMOWALLET,
} from "../../../store/actions.type.js";
import { mapGetters } from "vuex";
export default {
  name: "EditAccountComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    "main-loader": LoaderComponent,
  },
  data() {
    return {
      sendersFrom: [],
      sendersFromfields: [
        {
          key: "country",
          label: "Country",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "name",
          label: "Sender Name",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "email",
          label: "Email",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "mobile",
          label: "Mobile",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "block_status",
          label: "Block Status",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      sendersTo: [],
      sendersTofields: [
        {
          key: "country",
          label: "Country",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "name",
          label: "Sender Name",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "email",
          label: "Email",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "mobile",
          label: "Mobile",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "block_status",
          label: "Block Status",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      receivers: [],
      receiversfields: [
        {
          key: "country",
          label: "Country",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "name",
          label: "Receiver Name",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "email",
          label: "Email",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "mobile",
          label: "Mobile",
          sortable: false,
          thClass: "th_sortfix",
        },
        {
          key: "block_status",
          label: "Block Status",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],
      blockStatuses: [
        { value: "Monitor" },
        { value: "Restricted" },
        { value: "Suspended" },
        { value: "Terminated" },
        { value: "Blacklisted" },
        { value: "Approved" },
      ],
      breadCrumbIteams: [
        {
          title: "Customer",
          links: "",
        },
        {
          title: "Edit Accounts",
          links: "",
        },
      ],
    };
  },
  methods: {
    editCustomer(data) {
      this.$router.push({
        name: "customer-edit",
        params: {
          customer_id: this.$CryptoJS.AES.encrypt(
            data.item.id,
            "customer_id",
          ).toString(),
        },
      });
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      this.$toast.success(`${type} Copied`, { position: "top-right" });
    },
    // Get Customers Associated with a Bank Account
    async getCustomersbyBankAccounts() {
      let accountNumber = this.$CryptoJS.AES.decrypt(
        this.$route.query.value,
        "value",
      ).toString(this.$CryptoJS.enc.Utf8);
      const receiverstemp = [];
      const sendertemp = [];
      await this.$store
        .dispatch(GET_CUSTOMERS_BY_BANKACCOUNT, accountNumber)
        .then((response) => {
          if (response.status == 200) {
            let receiversdetails = response.data.receivers;
            let senderdetails = response.data.senders;
            receiversdetails.map((item) => {
              const beneficiaryfname = item.firstname ? item.firstname : "-";
              const beneficiarylname = item.lastname ? item.lastname : "-";
              let data = {
                id: item.id,
                name: beneficiaryfname + " " + beneficiarylname,
                country: this.countryList.filter(
                  (item1) => item1.countryid === item.countryofresidence,
                )[0],
                email: item.email ? item.email : "-",
                mobile: item.mobile ? item.mobile : "-",
              };
              receiverstemp.push(data);
            });
            senderdetails.map((item) => {
              const senderfname = item.firstname ? item.firstname : "-";
              const senderlname = item.lastname ? item.lastname : "-";
              let data = {
                id: item.id,
                name: senderfname + " " + senderlname,
                country: this.countryList.filter(
                  (item1) => item1.countryid === item.countryofresidence,
                )[0],
                email: item.email ? item.email : "-",
                mobile: item.mobile ? item.mobile : "-",
              };
              sendertemp.push(data);
            });
          }
          this.receivers = receiverstemp;
          this.sendersTo = sendertemp;
        });
    },

    // Get Customers Associated with a MoMo Wallet
    async getCustomersbyMoMoWallet() {
      let momonumber = this.$CryptoJS.AES.decrypt(
        this.$route.query.value,
        "value",
      ).toString(this.$CryptoJS.enc.Utf8);
      const receiverstemp = [];
      const sendertemp = [];
      await this.$store
        .dispatch(GET_CUSTOMERS_BY_MOMOWALLET, momonumber)
        .then((response) => {
          if (response.status == 200) {
            let receiversdetails = response.data.receivers;
            let senderdetails = response.data.senders;
            receiversdetails.map((item) => {
              const beneficiaryfname = item.firstname ? item.firstname : "-";
              const beneficiarylname = item.lastname ? item.lastname : "-";
              let data = {
                id: item.id,
                name: beneficiaryfname + " " + beneficiarylname,
                country: this.countryList.filter(
                  (item1) => item1.countryid === item.countryofresidence,
                )[0],
                email: item.email ? item.email : "-",
                mobile: item.mobile ? item.mobile : "-",
              };
              receiverstemp.push(data);
            });
            senderdetails.map((item) => {
              const senderfname = item.firstname ? item.firstname : "-";
              const senderlname = item.lastname ? item.lastname : "-";
              let data = {
                id: item.id,
                name: senderfname + " " + senderlname,
                country: this.countryList.filter(
                  (item1) => item1.countryid === item.countryofresidence,
                )[0],
                email: item.email ? item.email : "-",
                mobile: item.mobile ? item.mobile : "-",
              };
              sendertemp.push(data);
            });
          }
          this.receivers = receiverstemp;
          this.sendersTo = sendertemp;
        });
    },
  },
  async mounted() {
    const type = this.$CryptoJS.AES.decrypt(
      this.$route.query.name,
      "name",
    ).toString(this.$CryptoJS.enc.Utf8);
    let temp = [
      {
        title: "Customer",
        links: "",
      },
      {
        title: "Edit Accounts",
        links: "",
      },
      {
        title: this.$CryptoJS.AES.decrypt(
          this.$route.query.name,
          "name",
        ).toString(this.$CryptoJS.enc.Utf8),
        links: "",
        isbold: true,
      },
      {
        title: this.$CryptoJS.AES.decrypt(
          this.$route.query.value,
          "value",
        ).toString(this.$CryptoJS.enc.Utf8),
        links: "",
        isbold: true,
      },
    ];
    this.breadCrumbIteams = temp;
    if (type == "Bank Account") {
      await this.getCustomersbyBankAccounts();
    }
    if (type == "MOMO Account") {
      await this.getCustomersbyMoMoWallet();
    }
  },
  computed: {
    ...mapGetters(["countryList", "isLoading"]),
  },
};
</script>
